import styled from '@emotion/styled'
import theme from '@utils/theme'

// SideBar Animation for smooth popup

interface SidebarProps {
  open?: boolean
}

// Sidebar Animation
export const SidebarWrapper = styled.div<SidebarProps>`
  position: fixed;
  top: 0;
  right: 0;
  width: 400px;
  height: 100vh; // Add this
  background: white;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 0.3s ease-in-out;
  z-index: 1000;
  overflow: hidden; // Add this

  @media (max-width: 1024px) {
    width: 100vw;
  }
`

// Overlay Animation
export const Overlay = styled.div<SidebarProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  opacity: ${({ open }) => (open ? 1 : 0)};
  visibility: ${({ open }) => (open ? 'visible' : 'hidden')};
  transition:
    opacity 0.3s ease-in-out,
    visibility 0.3s ease-in-out;
  z-index: 999;
`
// SideBar Styles

export const SideBarContainer = styled.div`
  background: #f8fbff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;

  @media (max-width: 640px) {
    height: 100vh;
    margin: 0 -12px;
    padding: 10px 12px;
  }
`
export const ProfileCard = styled.div`
  width: 100%;
  background: white;
  padding: 20px;
  border-radius: 10px;
  display: flex;
  items-align: center;
  gap: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
`
export const Name = styled.h2`
  margin: 5px 0 5px;
  font-size: 18px;
  font-weight: bold;
`
export const ContactInfo = styled.p`
  font-size: 14px;
  color: #555;
  display: flex;
  align-items: center;
  gap: 5px;
`
export const SubscriptionCard = styled.div`
  width: 100%;
  background: white;
  padding: 15px;
  margin: 15px 0;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  border: 1px solid ${theme.colors.borderBlue};
  color: ${theme.colors.primary};
`

export const SubscriptionActions = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
  justify-content: flex-end;
`
export const Button = styled.button`
  color: white;
  padding: 8px 12px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
`
export const Menu = styled.div`
  width: 100%;
  background: white;
  padding: 5px 10px;
  margin: 10px 0;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
`
export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  font-size: 14px;
  cursor: pointer;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }
`

// Styled Components
const NavbarContainer = styled.div`
  padding: 12px 0;
  width: 100%;
  @media (max-width: 768px) {
    padding: 0;
  }
`

const TopRow = styled.div`
  display: none;
  @media (max-width: 1024px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 16px;
  }
`

const BottomRow = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 8px;

  @media (min-width: 1024px) {
    display: none;
  }
`

const DesktopRow = styled.div`
  display: none;

  @media (min-width: 1024px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 32px;
  }
`

const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  gap: 32px;
`

const SearchWrapper = styled.div`
  position: relative;
  flex: 1;
  max-width: 100%;
  @media (min-width: 768px) {
    width: 250px;
    margin-left: 32px;
  }
`

const SearchInput = styled.input<any>`
  width: 100%;
  height: 40px;
  padding: 8px 16px 8px 36px;
  border-radius: 8px;
  border: 1px solid
    ${(props) =>
      props.isFocus
        ? props.theme.colors.primary
        : props.theme.colors.inputBorder};
  outline: none;
  font-size: 14px;

  &::placeholder {
    color: #999;
  }
`

const SearchIconWrapper = styled.div`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
`

const Dropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  z-index: 1000;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 5px;
  max-height: 400px;
  overflow-y: auto;
  opacity: 0;
  transform: translateY(-10px);
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;

  &.visible {
    opacity: 1;
    transform: translateY(0);
  }
  &::-webkit-scrollbar {
    display: none;
  }
`

const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background: #f5f5f5;
  }
`

const BookImage = styled.img`
  width: 60px;
  height: 80px;
  object-fit: cover;
  border-radius: 5px;
  margin-right: 10px;
`

const BookInfo = styled.div`
  flex: 1;
`

const BookTitle = styled.div`
  font-weight: bold;
  font-size: 20px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`

const BookAuthor = styled.div`
  font-size: 12px;
  color: gray;
`

const BookCategory = styled.div`
  background: rgb(71, 194, 98);
  padding: 4px 8px;
  border-radius: 5px;
  font-size: 12px;
  color: white;
`
const ResponsiveButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
`

const NoResultsMessage = styled.div`
  padding: 16px;
  text-align: center;
  color: #666;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const LoadingMessage = styled.div`
  padding: 16px;
  text-align: center;
  color: #666;
  font-size: 14px;
  font-style: italic;
`

export {
  NavbarContainer,
  TopRow,
  BottomRow,
  DesktopRow,
  ActionContainer,
  SearchWrapper,
  SearchInput,
  SearchIconWrapper,
  Dropdown,
  DropdownItem,
  BookImage,
  BookInfo,
  BookTitle,
  BookAuthor,
  BookCategory,
  ResponsiveButton,
  NoResultsMessage,
  LoadingMessage,
}

// Phone Nav Styles

export const NavContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 60px;
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 1000;
`

interface NavItemProps {
  active?: boolean
}

export const NavItem = styled.div<NavItemProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.active ? '#0077cc' : '#333')};
  font-size: 12px;
  cursor: pointer;
  padding: 8px 0;
  width: 20%;
`

export const CenterButton = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: #0077cc;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  position: relative;
  bottom: 20px;
  cursor: pointer;
`
export const StyleNotificationWrapper = styled.div`
  position: relative;
`
export const StyleNotificationContainer = styled.div`
  position: absolute;
  width: 30%;
  height: 600px;
  right: 2%;
  top: 80px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  background-color: #ffffff;
`
export const StyledCountWrapper = styled.div`
  position: absolute;
  background-color: red;
  height: 18px;
  width: 18px;
  border-radius: 999px;
  right: 0px;
  top: -4px;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 14px;
  color: #ffff;
`
